module.exports = "<app-discount-person-list></app-discount-person-list>\r\n"